import { getStaticPropsGenerator } from '@cinch-nx/landing-feature-articles-sub-hub'

const path = 'announcements/cinch-news'
const resultsPerPage = 10

export const getStaticProps = getStaticPropsGenerator({
  subHubPath: path,
  resultsPerPage,
  breadCrumbs: [
    { text: 'Home', url: '/' },
    { text: 'cinch news', url: `/${path}` },
  ],
})

export { ArticleSubHubFeature as default } from '@cinch-nx/landing-feature-articles-sub-hub'
